export default function topWindowWithSameOrigin(window)
{
	window = window || self;
	while(window.frameElement)
	{
		window = window.parent;
	}
	return window;
}